import { rules } from "@/mocks/communityData";

export default function Community() {
  return (
    <section id="community" aria-label="社区公约与互动规范" className="w-full bg-background-100 py-16 md:py-24">
      <div className="container-x grid gap-10 lg:grid-cols-[0.95fr_1.05fr] lg:items-center">
        {/* left narrative + image */}
        <div>
          <span className="tag-primary"><i className="ri-shield-check-line"></i>Community Rules</span>
          <h2 className="mt-3 text-2xl font-black tracking-tight text-foreground-950 md:text-4xl">
            吃瓜也要
            <span className="text-primary-500">讲规矩</span>
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            聊得热闹不等于没有边界。吃瓜聚集相信，一个好玩的讨论区，
            恰恰建立在互相尊重与信息求真之上。以下是每一位瓜友共同守护的公约，也让这里的每一次发言都更值得被听见。
          </p>

          <div className="relative mt-8 overflow-hidden rounded-2xl ring-1 ring-background-200">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20flat%20illustration%20of%20people%20chatting%20online%20in%20a%20healthy%20friendly%20community%2C%20a%20protective%20shield%20and%20heart%20symbols%20above%20them%2C%20speech%20bubbles%20with%20thumbs%20up%20and%20checkmarks%2C%20cream%20background%20with%20coral%20green%20and%20amber%20accent%2C%20playful%20modern%20flat%20vector%2C%20soft%20shadows%2C%20clean%20balanced%20composition&width=900&height=620&seq=community-rules&orientation=landscape"
              alt="吃瓜聚集健康友善的讨论氛围插画"
              className="h-56 w-full object-cover object-top md:h-72"
            />
            <div className="absolute inset-x-0 bottom-0 flex flex-wrap items-center justify-between gap-3 bg-gradient-to-t from-background-950/80 to-transparent px-5 pb-4 pt-10">
              <span className="text-sm font-bold text-background-50">友善 · 真实 · 有温度</span>
              <a href="#feed" className="inline-flex cursor-pointer items-center gap-1 whitespace-nowrap rounded-full bg-accent-500 px-4 py-1.5 text-xs font-bold text-background-50 transition-colors hover:bg-accent-600">
                看大家都在聊什么 <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>
        </div>

        {/* rules grid */}
        <div className="grid gap-4 sm:grid-cols-2">
          {rules.map((r, i) => (
            <div
              key={r.title}
              className="card relative overflow-hidden p-6 transition-all duration-300 hover:-translate-y-1 hover:ring-primary-200"
            >
              <span className="pointer-events-none absolute right-4 top-3 font-heading text-5xl font-black text-background-200">
                {String(i + 1).padStart(2, "0")}
              </span>
              <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-primary-100 text-2xl text-primary-700">
                <i className={r.icon}></i>
              </span>
              <h3 className="mt-4 text-base font-black text-foreground-950">{r.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{r.desc}</p>
            </div>
          ))}

          <div className="col-span-full flex items-center gap-4 rounded-2xl bg-gradient-to-r from-accent-500 to-accent-600 px-6 py-5">
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-background-50/20 text-background-50">
              <i className="ri-megaphone-fill text-2xl"></i>
            </span>
            <p className="text-sm font-medium text-background-50">
              被一条热议吸引，却错过了完整前因？去<a href="#faq" className="font-bold underline underline-offset-2">常见问题</a>里找找答案，或直接发帖问问在线瓜友。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}